import { AppClient } from "@adapptio/core/src/client";

import { registerExtension as ExtIntegrationsBase } from "@adapptio/ext-integrations-base/src/client";
import { registerExtension as ExtFunctionsBase } from "@adapptio/ext-functions-base/src/client";
import { registerExtension as ExtComponentsBase } from "@adapptio/ext-components-base/src/client";
import { registerExtension as ExtComponentsPro } from "@adapptio/ext-components-pro/src/client";
import { registerExtension as ExtIconsMdi } from "@adapptio/ext-icons-mdi/src/client";
import { registerRuntimeTranslations as RuntimeTranslations } from "@adapptio/translations/src/runtime";

import "./main.scss";
//import "./custom.scss";

declare global {
	interface Window {
		APP_DEBUG: boolean;
		/* @todo !!! temporary !!! */
		__appInstance: AppClient;
	}
}

if (location.hash === "#__debug") {
	window.APP_DEBUG = true;
}
//window.APP_DEBUG = true;

const app = new AppClient();
window.__appInstance = app;

app.useExtension(ExtIntegrationsBase);
app.useExtension(ExtFunctionsBase);
app.useExtension(ExtComponentsBase);
app.useExtension(ExtComponentsPro);
app.useExtension(ExtIconsMdi);

app.useTranslations(RuntimeTranslations);

app.init();
